import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

const ROLE_KEYS = {
  SUPER_ADMIN: 'errors.forbiddenPage.roleHints.SUPER_ADMIN',
  SALON_MANAGER: 'errors.forbiddenPage.roleHints.SALON_MANAGER',
  SALON_STAFF: 'errors.forbiddenPage.roleHints.SALON_STAFF',
  CLIENT: 'errors.forbiddenPage.roleHints.CLIENT',
};

const ForbiddenPage = () => {
  const { t } = useTranslation();
  const { role } = useAuth();
  const roleHint = ROLE_KEYS[role]
    ? t(ROLE_KEYS[role])
    : t('errors.forbiddenPage.defaultRoleArea');

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
      <p className="text-5xl font-bold text-zinc-700">403</p>
      <h2 className="mt-4 text-xl font-medium text-zinc-900 dark:text-zinc-100">
        {t('errors.forbiddenPage.title')}
      </h2>
      <p className="mt-2 max-w-md text-sm text-zinc-600 dark:text-zinc-500">
        {t('errors.forbiddenPage.description', { role: roleHint })}
      </p>
      <Link
        to="/"
        className="mt-8 rounded-lg border border-zinc-300 dark:border-zinc-700 px-6 py-2.5 text-sm text-zinc-800 dark:text-zinc-200 hover:bg-zinc-100 dark:hover:bg-zinc-800"
      >
        {t('errors.forbiddenPage.goToDashboard')}
      </Link>
    </div>
  );
};

export default ForbiddenPage;
